import React from 'react';
import { VStack, Heading, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card';
import HomeLocationCard, { LocationData } from './HomeLocationCard';

interface LocationsData {
  locations: LocationData[];
}

interface HomeLocationsCardProps {
  sectionData: {
    data?: LocationsData;
  };
}

const HomeLocationsCard: React.FC<HomeLocationsCardProps> = ({
  sectionData,
}) => {
  const bgColor = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');

  if (!sectionData?.data) return null;

  const locations = sectionData.data.locations || [];

  if (locations.length === 0) return null;

  return (
    <Card bg={bgColor} p={6} borderColor={borderColor} borderWidth="1px">
      <VStack spacing={6} align="stretch">
        <Heading size="md" color={textColor}>
          Locations
        </Heading>

        <VStack spacing={4} align="stretch">
          {locations.map((location, index) => (
            <HomeLocationCard key={index} locationData={location} />
          ))}
        </VStack>
      </VStack>
    </Card>
  );
};

export default HomeLocationsCard;
